import React from 'react'
import { useTranslation } from 'react-i18next';
import './topIntro.scss';

import { PROJECT } from '../../constants';

const TopIntro = () => {
    const { t } = useTranslation();

    const text = PROJECT === 'vg' ? 
    {
        'mainTitle': t('titleMain_vg'),
        'subTitle': t('subTitle_vg'),
    } :
    {
        'mainTitle': t('titleMain'),
        'subTitle': t('subTitle'),
    }

    return (
        <div id='top_intro' className='row'>
            <div className={`${PROJECT === 'vg' ? "" : "shadow-bg"}`}>
                <div className="text-wrapper">
                    <div className="main-title">{text.mainTitle}</div>
                    <div className="sub-title">{text.subTitle}</div>
                </div>  
            </div>                      
        </div>
    )
}

export default TopIntro;
